// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.1406 3.91309L9 4.85742V19C9 21.2091 7.20914 23 5 23C2.79086 23 1 21.2091 1 19C1.00013 16.791 2.79094 15 5 15C5.72871 15 6.41158 15.1957 7 15.5361V3.14258L14.8359 1.93652L15.1406 3.91309Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 17C22 19.2091 20.2091 21 18 21C15.7909 21 14 19.2091 14 17C14.0001 14.791 15.7909 13 18 13C18.7287 13 19.4116 13.1957 20 13.5361V10H22V17Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.0322 3.4668L24.0693 4.75L21.0322 6.03223L19.75 9.06934L18.4668 6.03223L15.4307 4.75L18.4668 3.4668L19.75 0.430664L21.0322 3.4668Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-music-filled')
export default class AiMusicFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-music-filled',
    }
  }
}
